import styled from "styled-components";

export const ProfileHeaderWrapper = styled.div`
  background: beige 0% 0% no-repeat padding-box;
  padding: 2px;
  border-radius: 15px;
  position: relative;
  .outstandingAmount {
    float: right;
    font-size: 13px;
    font-weight: 600;
  }
  .imgBox {
    width: 172px;
    height: 188px;
    border-radius: 18px;
    // position: absolute;
    // top: 0px;
    // left: 0px;
    background-color: #fff;
    & > img {
      height: 100%;
      border-radius: 15px;
    }
    .editIcon {
      position: absolute;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #f3f3f3;
      position: absolute;
      right: -20px;
      top: 100px;
      img {
        width: 18.5px;
      }
    }
    img {
      width: 100%;
    }
  }

  .main {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 2px #00000014;
    border-radius: 13px;
    padding: 22px 18px;
    gap: 16px;
    align-items: start;
    min-height: 150px;

    .textBox {
      color: #082654;
      line-height: 25px;
      .title {
        width: 100px;
      }
      .value {
      
        font-weight: 600;
      }
    }
  }
  .bottom {
  // background:blue;
background-color: #eff6ff;
     
    padding-block: 12px;
    padding-inline: 20px;
    gap: 30px;
    text-align:center
    align-items: center;
    justify-content: center;
    button {
      max-width: 150px;
      height: 45px;
      font-size: 15px;
      font-weight: 600;
    }
  }
  @media only screen and (max-width: 768px) {
    .main {
      display: flex;
      // justify-content: center;
    }
    .bottom {
      margin-left: auto;
      font-size: 12px;
      line-height: 14px;
      flex-direction: column;
      gap: 10px;
      button {
        align-self: self-end;
        max-width: 120px;
        height: 30px;
        font-size: 12px;
      }
    }
    .imgBox {
      width: 140px;
      height: 155px;
      .editIcon {
        top: 80px;
      }
    }
  }
`;

export const DetailBoxWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  // align-items: center;
  background: #ffffff 0% 0% no-repeat padding-box;
  // box-shadow: 8px 4px 12px 2px rgba(255, 126, 95, 0.4); /* Soft warm shadow */
  border-radius: 15px;
  opacity: 1;
  padding: 22px;
  margin-right: auto;
  margin-left: auto;
  &:hover {
    box-shadow: 4px 4px 10px rgba(255, 136, 96, 0.3);
  }

  .header {
    display: flex;
    justify-content: space-between;
    gap: 40px;
    h2 {
      font-size: 20px;
      line-height: 24px;
    }
    .icons {
      color: #000;
      background-color: #f3f3f3;
      font-weight: 600;
      cursor: pointer;
      border-radius: 13px;
      height: 25px;
      width: 70px;
      transition: all 0.3s;
      gap: 4px;
      img {
        width: 15px;
      }
      &:hover {
        color: #fff;
        background: #26b9db;
        img {
          filter: invert(1);
        }
      }
    }
  }
  .main {
    margin-top: 30px;
    table {
      border: none;
      tr {
        td {
          padding: 0 0 0 0;
          font-size: 15px;
          line-height: 30px;
          color: #082654;
          &:first-child {
            padding-right: 30px;
          }
          &:last-child {
            font-weight: 600;
          }
        }
      }
    }
  }
`;

export const ProfilePreviewWrapper = styled.div`
  .detailBox {
    margin-block: 30px;
    display: flex;
    gap: 14px;
    flex-wrap: wrap;

    & > div {
      flex: 0.32 0 16%;
      min-width: 280px;
    }
  }
`;
